import { useSelector } from 'react-redux';
import { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Form, Typography, message, Spin, Tabs } from 'antd';
import EbzModal from 'components/EbzModal';
import merchantAPI from 'services/merchants';
import submerchantAPI from 'services/submerchants';
import Alert from 'components/Alert';
import MerchantSignUpForm from './form/MerchantSignupForm';
import SubmerchantSignupForm from './form/SubmerchantSignupForm';

function ReferralSignUpModal({
  signUpModelDisplay,
  toggleModal,
  signupLoading,
  submitButtonDisable,
  setSignupLoading,
  setSubmitButtonDisable,
  fetchReferralsList,
  isMerchantSignUpAllowed,
  isSubmerchantSignUpAllowed
}) {
  const tabList = [];
  if (isMerchantSignUpAllowed) {
    tabList.push({ key: 'merchant', label: 'Merchant' });
  }

  if (isSubmerchantSignUpAllowed) {
    tabList.push({ key: 'submerchant', label: 'Sub-Merchant' });
  }

  const filteredListKey = tabList.filter((element, index) => index === 0);
  const [activeTab, setActiveTab] = useState(filteredListKey[0]?.key);
  const recaptchaRef = useRef();
  const [merchantSignUpForm] = Form.useForm();
  const [submerchantSignUpForm] = Form.useForm();
  const refCode = useSelector((state) => state.user.currentUser?.ref_code);

  // const errorList = (errors) => {
  //   return Object.entries(errors).map(([key, value]) => (
  //     <div
  //       style={{
  //         display: 'flex',
  //         flexDirection: 'row',
  //         justifyContent: 'flex-start',
  //         alignItems: 'center',
  //         margin: '8px 0'
  //       }}
  //     >
  //       <Typography.Title level={5} style={{ margin: 0 }}>
  //         {key} :
  //       </Typography.Title>
  //       &nbsp;
  //       <Typography.Text style={{ marginLeft: '8px' }}>{value}</Typography.Text>
  //     </div>
  //   ));
  // };

  const handleResetData = (formType) => {
    recaptchaRef.current.reset();
    if (formType === 'merchant') {
      merchantSignUpForm.resetFields();
    }
    if (formType === 'submerchant') {
      submerchantSignUpForm.resetFields();
    }
  };

  const sendSignUp = async (request, formType) => {
    const token = await recaptchaRef.current.executeAsync();
    const payload = { ...request, recaptcha_token: token };

    const response =
      formType === 'merchant'
        ? await merchantAPI.createReferralSignup(payload)
        : await submerchantAPI.createSubmerchantSignup(payload);

    if (response.success) {
      toggleModal();
      handleResetData();
      fetchReferralsList();
      message.success('Signup successfully.');
    } else {
      setSignupLoading(false);
      setSubmitButtonDisable(false);
      handleResetData();
      Alert('Oops', response?.data?.error?.message, 'error');
    }
  };

  const handleFormSubmit = (formType) => (payload) => {
    setSignupLoading(true);
    setSubmitButtonDisable(true);
    const request = { ...payload, ref_code: refCode };
    sendSignUp(request, formType);
  };

  useEffect(() => {
    if (refCode && signUpModelDisplay) {
      setSubmitButtonDisable(false);
      merchantSignUpForm.resetFields();
      submerchantSignUpForm.resetFields();
      merchantSignUpForm.setFieldsValue({
        email: '',
        password: ''
      });
      merchantSignUpForm.setFieldValue('ref_code', refCode);
    }
  }, [refCode, signUpModelDisplay]);

  return (
    <EbzModal
      title={
        <Typography.Title
          style={{ fontSize: '18px', display: 'flex', justifyContent: 'center' }}
          level={4}
        >
          Signup
        </Typography.Title>
      }
      toggleModal={toggleModal}
      onClose={toggleModal}
      width="700px"
      isOpen={signUpModelDisplay}
      scroll={{ y: '240px' }}
    >
      <Tabs centered activeKey={activeTab} onChange={(key) => setActiveTab(key)} items={tabList} />

      <Spin spinning={signupLoading}>
        {/* ------------------------------------------------------- */}
        {/* --------------------- MERCHANT FORM ------------------- */}
        {/* ------------------------------------------------------- */}
        {activeTab === 'merchant' && (
          <MerchantSignUpForm
            merchantSignUpForm={merchantSignUpForm}
            handleFormSubmit={handleFormSubmit}
            submitButtonDisable={submitButtonDisable}
            recaptchaRef={recaptchaRef}
          />
        )}
        {/* ------------------------------------------------------- */}
        {/* --------------------- SUBMERCHANT FORM ------------------- */}
        {/* ------------------------------------------------------- */}
        {activeTab === 'submerchant' && (
          <SubmerchantSignupForm
            submerchantSignUpForm={submerchantSignUpForm}
            handleFormSubmit={handleFormSubmit}
            submitButtonDisable={submitButtonDisable}
            recaptchaRef={recaptchaRef}
          />
        )}
      </Spin>
    </EbzModal>
  );
}
ReferralSignUpModal.propTypes = {
  signUpModelDisplay: PropTypes.bool.isRequired,
  signupLoading: PropTypes.bool.isRequired,
  submitButtonDisable: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  setSubmitButtonDisable: PropTypes.func.isRequired,
  setSignupLoading: PropTypes.func.isRequired,
  fetchReferralsList: PropTypes.func.isRequired,
  isMerchantSignUpAllowed: PropTypes.bool.isRequired,
  isSubmerchantSignUpAllowed: PropTypes.bool.isRequired
};

export default ReferralSignUpModal;
